export const applyLearningCourses = () =>
    `mutation applyLearningCourses($courses: [LearningCourseInput!]!) {
      applyLearningCourses(
        courses: $courses
      )
    }`;

export const getLearningCourses = () =>
    `query getLearningCourses {
      learningCourses {
        id
        name
        externalId
        active
      }
    }`;

export const getCourseMapping = () =>
    `query getCourseMapping {
      courseMapping {
        fileReferenceName
        creationTime
        mappings {
          pocField
          lmsField
          targetEntity
        }
        fallbacks {
          pocField
          lmsField
          targetEntity
        }
      }
    }`;

export const createCourseMappings = () => `
  mutation createCourseMappings($mapping: CourseMappingInput!) {
    createCourseMappings(mapping: $mapping)
  }
`;
